import React, { useEffect, useState, useMemo, useContext } from "react";
import { TextField, Button } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";

import DataTable from "react-data-table-component";

import useCity from "../../queries/city/getCities";
import useProperties from "../../queries/property/getProperties";

import Loader from "../../components/Loader";
import Toast from "../../utils/Toast";
import Swal from "sweetalert2";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AuthContext } from "../../utils/userProvider";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
} from "../../components/ListPage";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
});

const City = () => {
  const [cityTable, setCityTable] = useState([]);
  const { authState, setAuthState } = useContext(AuthContext);

  let columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
    },
    {
      name: "Property(s)",
      selector: "suiteText",
      sortable: false,
    },
  ];

  columns.push({
    name: "Options",
    sortable: false,
    cell: (row, index, column, id) => {
      if (authState.editAccess) {
        if (!row.archived) {
          return (
            <div>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<CreateIcon />}
                onClick={() => {
                  editItem(row);
                }}
              >
                Edit
              </Button>
            </div>
          );
        }
      } else {
        if (!row.archived) {
          return (
            <div>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={() => {
                  editItem(row);
                }}
              >
                View
              </Button>
            </div>
          );
        }
      }
    },
  });

  const editItem = (value) => {
    if (authState.editAccess) {
      window.location.href = "/dashboard/city/edit/" + value.id;
    } else {
      window.location.href = "/dashboard/city/view/" + value.id;
    }
  };

  const [cityResponse, resetCity] = useCity();
  const [propertiesResponse, resetProperties] = useProperties();

  const [filterText, setFilterText] = useState("");

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = cityTable.filter(
    (item) =>
      (item.name &&
        item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.suiteText &&
        item.suiteText.toLowerCase().includes(filterText.toLowerCase()))
  );

  const newCity = () => {
    window.location.href = "/dashboard/city/new";
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div>
        <TextField
          id="filter-text"
          onChange={handleFilterText}
          label="Search"
          variant="outlined"
          size="small"
        />
      </div>
    );
  }, [filterText]);

  useEffect(() => {
    if (propertiesResponse.data && cityResponse.data) {
      let cities = cityResponse.data;
      let properties = propertiesResponse.data;

      for (var i = 0; i < cities.length; i++) {
        let propertyText = "";
        if (cities[i].suites && cities[i].suites.ids) {
          let suiteIds = cities[i].suites.ids;
          for (var a = 0; a < suiteIds.length; a++) {
            let suiteId = typeof suiteIds[a] === "number" ? suiteIds[a] : parseInt(suiteIds[a], 10);
            let property = properties.find(
              (ele) => ele.suiteIds?.ids && Array.isArray(ele.suiteIds.ids) && ele.suiteIds.ids.includes(suiteId)
            );
            if (property) {
              propertyText += property.name + ` (Suite ID: ${suiteId})` + ", ";
            }
          }
        }
        if (propertyText.length > 0) {
          propertyText = propertyText.slice(0, -2);
        }
        cities[i].suiteText = propertyText;
      }

      setCityTable(cities);
    }
  }, [propertiesResponse, cityResponse]);

  return (
    <ListPageShell>
      <ListPageCard>
        {(cityResponse.loading || propertiesResponse.loading) && <Loader />}
        {!cityResponse.loading && !propertiesResponse.loading && (
          <div>
            <ListPageHeader
              title="City"
              actions={
                authState.role == "Executive" ? (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={newCity}
                  >
                    Create New City
                  </Button>
                ) : null
              }
            />
            <DataTable
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10]}
              noHeader={true}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
              data={filteredItems}
              columns={columns}
              customStyles={dataTableCustomStyles}
            />
          </div>
        )}
      </ListPageCard>
    </ListPageShell>
  );
};

export default City;
